function dateSplitDirective() {
    'ngInject';

    return {
        restrict: 'A',
        require: ['ngModel'],
        link(scope, element, attrs, ctrls) {

            const ngModel = ctrls[0];

            const question = scope.$eval(attrs.bbDateSplit);

            question.date = {
                day: null,
                month: null,
                year: null,
                date: null,

                joinDate() {
                    if (this.day && this.month && this.year) {
                        let date_string = this.day + '/' + this.month + '/' + this.year;
                        this.date = moment(date_string, 'DD/MM/YYYY');
                        date_string = this.date.toISODate();

                        ngModel.$setViewValue(date_string);
                        return ngModel.$render();
                    }
                },

                splitDate(date) {
                    if (date && date.isValid()) {
                        this.day = date.date();
                        this.month = date.month() + 1;
                        this.year = date.year();
                        return this.date = date;
                    }
                }
            };

            // split the date if it's already set
            if (question.answer) {
                question.date.splitDate(moment(question.answer));
            }
            if (ngModel.$viewValue) {
                return question.date.splitDate(moment(ngModel.$viewValue));
            }
        }
    };
}

angular
    .module('BB')
    .directive('bbDateSplit', dateSplitDirective);


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/date-split/date_split.directive.js